import React from 'react';

const Requests = () => {
  return (
    <div>
      <h1>Requests</h1>
    </div>
  );
};

export default Requests;